import cmsPageRepository from '../repositories/cmsPageRepository';

const cmsPageService = {
  getCmsResult: async ({url}) => {
    return await cmsPageRepository.getCmsResult({url});
  },
};

export default cmsPageService;
